import LatencyIcon from "../fragments/icons/Latency";
import Logo from "../fragments/icons/Logo";
import ProfileButton from "../fragments/ProfileButton";
import useWebSocket from "../hooks/useWebSocket";

const Header = ({ user, setSidebarOpen }) => {
  const { latency } = useWebSocket();
  return (
    <header className="relative h-12 lg:h-16 z-20 bg-gradient-to-br from-green-600 to-primary-600 shadow">
      <div className="flex justify-between items-center px-4 lg:px-8 py-2">
        <a
          href="/app/"
          className="flex items-center gap-x-4 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded-md"
        >
          <Logo className="h-8 w-auto lg:h-12 text-white" />
          <h1 className="inline text-white lg:text-3xl text-2xl tracking-tight font-medium">
            TriviaRoyale
          </h1>
        </a>
        <div className="-mr-1 -my-1 lg:hidden">
          <button
            type="button"
            className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-primary-600 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">{gettext("Open sidebar")}</span>
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h7"
              />
            </svg>
          </button>
        </div>
        <div className="hidden lg:flex justify-end gap-x-4">
          <ProfileButton user={user} />
          <div
            title={`${latency} ms`}
            className="flex items-center gap-x-2 bg-primary-700 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white"
          >
            <LatencyIcon latency={latency} />
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
